module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b8cc62dee2cc8a56df12748b96943dbc.gif";